import { render, staticRenderFns } from "./RegionList.vue?vue&type=template&id=f18f33ae&scoped=true"
import script from "./RegionList.vue?vue&type=script&lang=js"
export * from "./RegionList.vue?vue&type=script&lang=js"
import style0 from "./RegionList.vue?vue&type=style&index=0&id=f18f33ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f33ae",
  null
  
)

export default component.exports